module.exports = __webpack_public_path__ + "static/staff-1d671102806e285d55e17d5d4fa1d929.jpg";